import { render, staticRenderFns } from "./ProductReplicaTable.vue?vue&type=template&id=b6d3681e&scoped=true"
import script from "./ProductReplicaTable.vue?vue&type=script&lang=js"
export * from "./ProductReplicaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d3681e",
  null
  
)

export default component.exports